import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["password", "passwordConfirmation", "generateButton", "togglePassword"]

  connect() {
    console.log("Password generator controller connected")
  }

  generate() {
    const password = this.generateSecurePassword()
    
    // Set both password fields
    this.passwordTarget.value = password
    this.passwordConfirmationTarget.value = password
    
    // Trigger change event to ensure validation happens
    this.passwordTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.passwordConfirmationTarget.dispatchEvent(new Event('input', { bubbles: true }))
    
    // Optional: Show feedback
    this.showFeedback()
  }

  toggleBothPasswords(event) {
    const passwordField = this.passwordTarget
    const confirmationField = this.passwordConfirmationTarget
    const icon = this.togglePasswordTarget
    
    if (passwordField.type === "password") {
      // Show both passwords
      passwordField.type = "text"
      confirmationField.type = "text"
      icon.classList.remove("fa-eye")
      icon.classList.add("fa-eye-slash")
    } else {
      // Hide both passwords
      passwordField.type = "password"
      confirmationField.type = "password"
      icon.classList.remove("fa-eye-slash")
      icon.classList.add("fa-eye")
    }
  }

  generateSecurePassword() {
    // Character sets for password generation
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const lowercase = 'abcdefghijklmnopqrstuvwxyz'
    const numbers = '0123456789'
    const special = '!@#$%^&*()_+-=[]{}|;:,.<>?'
    
    const allChars = uppercase + lowercase + numbers + special
    const length = 10 // Strong password length
    
    let password = ''
    
    // Ensure at least one character from each set
    password += uppercase[Math.floor(Math.random() * uppercase.length)]
    password += lowercase[Math.floor(Math.random() * lowercase.length)]
    password += numbers[Math.floor(Math.random() * numbers.length)]
    password += special[Math.floor(Math.random() * special.length)]
    
    // Fill the rest randomly
    for (let i = password.length; i < length; i++) {
      password += allChars[Math.floor(Math.random() * allChars.length)]
    }
    
    // Shuffle the password to avoid predictable pattern
    return password.split('').sort(() => Math.random() - 0.5).join('')
  }

  showFeedback() {
    if (this.hasGenerateButtonTarget) {
      const originalText = this.generateButtonTarget.textContent
      this.generateButtonTarget.textContent = '✓ Password Generated'
      this.generateButtonTarget.classList.add('btn-success')
      
      setTimeout(() => {
        this.generateButtonTarget.textContent = originalText
        this.generateButtonTarget.classList.remove('btn-success')
      }, 2000)
    }
  }
}
